import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiTransactionService } from '@services/api-transaction.service';
import { CouponModel } from '@shared/models/CouponModel';
import { CustomerGiveawayModel, CustomerGiveawayRegisterModel } from '@shared/models/CustomerModel';
import { Country, GiveawayProductType, GiveawayType } from '@shared/models/Enums';
import { ScratchModel } from '@shared/models/ScratchModel';

@Component({
    selector: 'app-scratch-box',
    templateUrl: './scratch-box.component.html',
    styleUrls: ['./scratch-box.component.scss']
})
export class ScratchBoxComponent implements AfterViewInit {

    @Input() coupon: CouponModel;
    @Input() selectedScratch: ScratchModel;
    @Input() isWinner: boolean = false;
    @Input() customerId: number;
    @Input() transactionPackageId: number = null;
    @Input() country: Country = null;
    @Input() uniqueLinkCode: string = null;
    @Input() lastStickerId: number = null;
    @Output() claimGiveaway: EventEmitter<void> = new EventEmitter<void>();
    
    @ViewChild('scratcherCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
    @Output() onCloseEvent: EventEmitter<void> = new EventEmitter<void>(); 

    firstScratch = true;
    showClaim = false;
    
    hideCanvas = false;

    ctx!: CanvasRenderingContext2D;
    isScratching = false;

    constructor(public apiTransactionService: ApiTransactionService,){
        
    }

    ngAfterViewInit() {

        if (this.canvasRef && this.canvasRef.nativeElement) {

            this.setupCanvas();
        }
    }

    onClose(){
        this.onCloseEvent.emit();
    }

    onClaimGiveaway(){

        setTimeout(()=>this.hideCanvas = true, 500)
        this.claimGiveaway.emit();
    }

    openGiviApp() {

        window.open("https://migivi.com/login");//?enableLogin=true
    }

    setupCanvas() {

        const canvas = this.canvasRef.nativeElement;
        this.ctx = canvas.getContext('2d');
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
    
        // Cubrir el canvas
        this.ctx.fillStyle = '#c0c0c0'; // Color de la capa a raspar
        this.ctx.fillRect(0, 0, canvas.width, canvas.height);
    
        // Eventos de mouse
        canvas.addEventListener('mousedown', this.startScratch.bind(this));
        canvas.addEventListener('mousemove', this.scratch.bind(this));
        canvas.addEventListener('mouseup', this.stopScratch.bind(this));
        canvas.addEventListener('mouseleave', this.stopScratch.bind(this));
    
        // Eventos táctiles para dispositivos móviles
        canvas.addEventListener('touchstart', this.startScratch.bind(this), { passive: false });
        canvas.addEventListener('touchmove', this.scratch.bind(this), { passive: false });
        canvas.addEventListener('touchend', this.stopScratch.bind(this), { passive: false });
    }
    
    startScratch(event: MouseEvent | TouchEvent) {

        //first time the user scratch
        if(this.firstScratch){

            this.firstScratch = false;  

            let customerGiveaway = new CustomerGiveawayRegisterModel({
                scratchId: this.selectedScratch?.id,
                customerId: this.customerId,
                type: GiveawayType.Lotto,
                productType: GiveawayProductType.Coupons,
                productId: this.isWinner ? this.coupon.id : null,
                productName:  this.isWinner ? this.coupon.name : null,
                deleteFromEnv: this.isWinner ? true : false
            });

            if(this.uniqueLinkCode != null) customerGiveaway.uniqueLinkCode = this.uniqueLinkCode;

            if(this.transactionPackageId != null){
                customerGiveaway.transactionPackageId = this.transactionPackageId;
            }

            if(this.lastStickerId != null) customerGiveaway.loyaltyPlanCustomerStickerId = this.lastStickerId;

            //call to assign the giveaway
            this.apiTransactionService.postCustomerGiveaway(customerGiveaway, this.country).then(res =>{

                if(this.isWinner) this.showClaim = true;

            }).catch(()=>{

                this.showClaim = false;
            })
        };

        event.preventDefault();
        this.isScratching = true;
        this.scratch(event);
    }
    
    scratch(event: MouseEvent | TouchEvent) {

        if (!this.isScratching) return;
        event.preventDefault();
    
        let x, y;
        if (event instanceof MouseEvent) {
        const rect = this.canvasRef.nativeElement.getBoundingClientRect();
        x = event.clientX - rect.left;
        y = event.clientY - rect.top;
        } else if (event.touches) {
        const rect = this.canvasRef.nativeElement.getBoundingClientRect();
        x = event.touches[0].clientX - rect.left;
        y = event.touches[0].clientY - rect.top;
        }
    
        // Configura el "pincel" para el efecto de raspado
        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.beginPath();
        this.ctx.arc(x, y, 20, 0, Math.PI * 2);
        this.ctx.fill();
    }
    
    stopScratch() {

        this.isScratching = false;
    }
}
